import React, { useEffect } from "react"

import { Container, CardBody, Card } from "reactstrap"
//redux

import Breadcrumb from "components/Common/Breadcrumb"
import AllSingleItems from "../Single Item Master"

const BudgetMaster = () => {
  useEffect(() => {
    document.title = "Budget Master | Peacock Accountants Limited";
  }, [])

  return (
    <div>
      <div className="page-content mb-5">
        <Container fluid>
          <Breadcrumb title={"Dashboard"} breadcrumbItem={"Budget Master"} />

          <Card className="px-0 mx-0">
            <CardBody>
              <AllSingleItems
                api_name={"budget-master"}
                heading={"Budget"}
                title={"Budget Name"}
                fieldName={"name"}
                module_id={29}
                isDelete={false}
                isAddDelete={true}
              />
            </CardBody>
          </Card>
        </Container>
      </div>
    </div>
  )
}

export default BudgetMaster
